import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase'
import router from '@/router'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    appTitle : 'MOEX',
    user: null,
    error: null,    
    loading: false,
    loadingCirc: false,
    pictureError: null,
    profilePicURL: null,
    snackbar: null,
    groupsAsAdmin: null,
    groupsAsMember: null,
    usersForGroup: [],
    expensesForGroup: [],
    expensesForGroupAsMember: [],
    adminForGroup: null,
    typesForExpense: [],
    timeIntervall: null,
    expenseItems: [],
    expenseItemsMonthly: [],
    username: null,
    favouriteGroup: null,
    favouriteExpense: null,
    favouriteAdmin: null,
    buyerChartData: [],
    typeChartData: [],
    color: [],
    buyerChartLabels: [],
    typeChartLabels: [],
    profilePics: [],
    readyToRunChart: false,
    expenseItemsAll: []
  },
  mutations: {
    setReadyToRunChart (state, payload) {
      state.readyToRunChart = payload
    },
    setexpenseItemsAll (state, payload) {
      state.expenseItemsAll = payload
    },
    setFavouriteAdmin (state, payload) {
      state.favouriteAdmin = payload
    },
    setProfilePics (state, payload) {
      state.profilePics = payload
    },
    setFavouriteGroup (state, payload) {
      state.favouriteGroup = payload
    },
    setFavouriteExpense (state, payload) {
      state.favouriteExpense = payload
    },
    setUser (state, payload) {
      state.user = payload
    },
    setError (state, payload) {
      state.error = payload
    },    
    setLoading (state, payload) {
      state.loading = payload
    },
    setPictureError (state, payload) {
      state.pictureError = payload
    },
    setLoadingCirc (state, payload){
      state.loadingCirc = payload
    },
    setProfilePicURL (state, payload) {
      state.profilePicURL = payload
    },
    setSnackbar (state, payload) {
      state.snackbar = payload
    },
    setGroupsAsAdmin (state, payload) {
      state.groupsAsAdmin = payload
    },
    setGroupsAsMember (state, payload) {
      state.groupsAsMember = payload
    },
    setUsersForGroup (state, payload) {
      state.usersForGroup = payload
    },
    setExpensesForGroup (state, payload) {
      state.expensesForGroup = payload
    },
    setAdminForGroup (state, payload) {
      state.adminForGroup = payload
    },
    setExpensesForGroupAsMember(state, payload) {
      state.expensesForGroupAsMember = payload
    },
    setTypesForExpense(state, payload) {
      state.typesForExpense = payload
    },
    setTimeIntervall (state, payload) {
      state.timeIntervall = payload
    },
    setexpenseItems (state, payload) {
      state.expenseItems = payload
    },
    setexpenseItemsMonthly (state, payload) {
      state.expenseItemsMonthly = payload
    }
  },
  actions: {
    getFavourites ({commit}, payload) {
      firebase.firestore().collection('emailToUsername').where('email', '==', firebase.auth().currentUser.email).get().then(querySnapshot => {
        querySnapshot.forEach(doc => {
          commit('setFavouriteGroup', doc.data().favouriteGroup)
          commit('setFavouriteExpense', doc.data().favouriteExpense)
          commit('setFavouriteAdmin', doc.data().favouriteAdmin)
        })
      })
    },
    userSignUp ({commit}, payload) {
      commit('setLoading', true)
      firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password).then(firebaseUser => {
        commit('setLoading', false)
        commit('setError', null)
        var d = new Date()
        firebase.firestore().collection('emailToUsername').add({email: payload.email,username: payload.username, numberOfAdd: 0, numberOfGroups: 0, numberOfLogins: 0, userSignUpTime: d.getFullYear() + '/' + (d.getMonth()+1) + '/' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes()})
        firebase.auth().currentUser.sendEmailVerification().then(function () {
          commit('setLoading', false)
          commit('setError', 'Igazold vissza Email címed a bejelentkezéshez.')
        }).catch(function (error2) {
          commit('setError', error2.message)
          commit('setLoading', false)
        })
      }).catch(error => {
        commit('setError', error.message)
        commit('setLoading', false)
      })
    },
    userSignIn ({commit}, payload) {
      commit('setLoading', true)
      firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
      .then(firebaseUser => {
        if(!firebase.auth().currentUser.emailVerified){
          commit('setLoading', false)
          commit('setError', 'Belépés előtt igazold vissza email címed.')
          router.push('/login')
        } else {
          commit('setUser', {user: firebase.auth().currentUser , email: firebase.auth().currentUser.email})
          commit('setLoading', false)
          commit('setError', null)
          firebase.firestore().collection('emailToUsername').where('email', '==', firebase.auth().currentUser.email).get().then( querysnapshot => {
            querysnapshot.forEach( doc => {
              let numberLogins = doc.data().numberOfLogins
              numberLogins += 1
              var d = new Date()
              firebase.firestore().collection('emailToUsername').doc(doc.id).update({numberOfLogins: numberLogins,lastLogin: d.getFullYear() + '/' + (d.getMonth()+1) + '/' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes()})
            })
          })
          router.push('/home')
          router.push('/home')
        }        
      })
      .catch(error => {
        commit('setError', error.message)
        commit('setLoading', false)
      })
    },
    autoSignIn ({commit}, payload) {
      if(!firebase.auth().currentUser.emailVerified){
        commit('setUser', null)
      } else {
        commit('setUser', {user: payload , email: payload.email})
      }      
     },
    userSignOut ({commit}) {
      firebase.auth().signOut()
      commit('setUser', null)
      commit('setexpenseItems', null)
      commit('setexpenseItemsMonthly', null)
      router.push('/')
    },
    updateEmail ({commit}, payload) {
      commit('setLoading', true)
      firebase.auth().currentUser.updateEmail(payload.newEmail).then(event => {
          firebase.auth().currentUser.sendEmailVerification().then(function () {
            commit('setLoading', false)
            commit('setError', 'Igazold vissza Email címed a bejelentkezéshez. Majd jelentkezz be újra.')
            firebase.firestore().collection('emailToUsername').where('email', '==', payload.oldEmail).get().then( (querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                    let id = doc.id
                    firebase.firestore().collection('emailToUsername').doc(id).update({email: payload.newEmail}).then(event => {
                      commit('setUser', null)
                    }).catch(error3 => {
                      commit('setError', error3.message)
                      commit('setLoading', false)
                    })
                })
            })            
          }).catch(function (error2) {
            commit('setError', error2.message)
            commit('setLoading', false)
          })          
      }).catch(error => {
        commit('setLoading', false)
        commit('setError', error.message)
      })
    },
    updatePassword ({commit}, payload) {
      commit('setLoading', true)
      firebase.auth().currentUser.updatePassword(payload.newPassword).then(event => {
        commit('setLoading', false)
        commit('setError', 'Jelszó megváltoztatva. Lépj be újra.')   
        commit('setUser', null)   
      }).catch(error => {
        commit('setLoading', false)
        commit('setError', error.message)
      })

    },
    updateUserName ({commit}, payload) {
      commit('setLoading', true)
      firebase.firestore().collection('emailToUsername').where('email', '==', payload.email).get().then( (querySnapshot) => {
        querySnapshot.forEach((doc) => {
        let id = doc.id
        let color
        if(payload.color) {
          switch(payload.color) {
            case 'Piros':
              color = 'red'
              break
            case 'Kék':
              color = 'blue'
              break
            case 'Sárga':
              color = 'yellow'
              break
            case 'Zöld':
              color = 'green'
              break
            case 'Lila':
              color = 'purple'
              break
            case 'Narancs':
              color = 'orange'
              break
          }
        } else {
          color = 'grey'
        }
        firebase.firestore().collection('emailToUsername').doc(id).update({username: payload.newUserName, color: color}).then(event => {               
                commit('setLoading', false)
                commit('setError', 'Felhasználó név megváltoztatva.')
                }).catch(error => {
                  commit('setError', error.message)
                  commit('setLoading', false)
                })
            })
        })   
    },
    uploadPicture ({commit}, payload) {
      commit('setLoadingCirc', true)
      firebase.storage().ref('profilepictures/' + payload.email).put(payload.image).then(event => {
          commit('setLoadingCirc', false)
          commit('setPictureError', error.message)          
      }).catch( error2 => {
        commit('setLoadingCirc', false)
        commit('setPictureError', error2.message)
      })
    },
    downloadProfilePicture ({commit}, payload){
      commit('setLoadingCirc', true)
      firebase.storage().ref('profilepictures/' + payload.email).getDownloadURL().then( url => {
        commit('setProfilePicURL', url)
        commit('setLoadingCirc', false)
      }).catch( error => {
        commit('setProfilePicURL', url)
        commit('setLoadingCirc', false)
      })
    },        
    passwordReset ({commit}, payload) {
      commit('setLoading', true)
      firebase.auth().sendPasswordResetEmail(payload.email).then(event => {
        commit('setLoading', false)
        commit('setError', 'Email elküldve.')
      }).catch(error => {
        commit('setLoading', false)
        commit('setError', error)
      })
    },
    createGroup ({commit}, payload) {
      commit('setLoading', true)
      firebase.firestore().collection('groups').where('admin', '==', firebase.auth().currentUser.email).where('name', '==', payload.groupname).get().then( querysnapshot => {
        if (querysnapshot.docs.length > 0) { 
          commit('setLoading', false)
          commit('setSnackbar', 'Ilyen nevű csoport már létezik.')
        } else {   
          firebase.firestore().collection('emailToUsername').where('email', '==', firebase.auth().currentUser.email).get().then(querysnapshot => {
            querysnapshot.forEach( doc => {
              if(doc.data().numberOfGroups == 2){
                commit('setLoading', false)
                commit('setSnackbar', 'Teszt fázis alatt maximum 2 csoportod lehet.')
              } else {
                firebase.firestore().collection('groups').add({admin: firebase.auth().currentUser.email, expenseID: [], members: [firebase.auth().currentUser.email],name: payload.groupname}).then(event => {
                  firebase.firestore().collection('UsersToGroups').add({admin: firebase.auth().currentUser.email, groupname: payload.groupname, user: firebase.auth().currentUser.email}).catch( error3 => {
                    commit('setLoading', false)
                    commit('setSnackbar', error3.message)
                  })
                  firebase.firestore().collection('emailToUsername').where('email', '==', firebase.auth().currentUser.email).get().then(querysnapshot => {
                    querysnapshot.forEach( doc => {
                      let numberofgroups = doc.data().numberOfGroups
                      numberofgroups += 1
                      firebase.firestore().collection('emailToUsername').doc(doc.id).update({numberOfGroups: numberofgroups})
                    })
                  })
                  commit('setLoading', false)
                  commit('setSnackbar', 'Csoport "' + payload.groupname + '" létrehozva')
                }).catch( error => {
                  commit('setLoading', false)
                  commit('setSnackbar', error.message)
                })
              }
            })
          })  
        }
      }) 
      firebase.firestore().collection('groups').onSnapshot( doc => {
        let tmpGroups = []
        firebase.firestore().collection('groups').where('admin', '==', firebase.auth().currentUser.email).get().then( querysnapshot => {
          querysnapshot.forEach( doc => {
            tmpGroups.push({name: doc.data().name})
          })
        })
        commit('setGroupsAsAdmin', tmpGroups)
      })   
    },
    getGroupsAsMember ({commit}, payload) {
      let tmpGroups = []
      firebase.firestore().collection('UsersToGroups').where('user', '==', firebase.auth().currentUser.email).get().then( querysnapshot => {
        querysnapshot.forEach( doc => {          
          tmpGroups.push({name: doc.data().groupname, admin: doc.data().admin})                 
        })
      })
      commit('setGroupsAsMember', tmpGroups)
    },
    getGroupsAsAdmin ({commit}, payload) {
      let tmpGroups = []
      firebase.firestore().collection('groups').where('admin', '==', firebase.auth().currentUser.email).get().then( querysnapshot => {
        querysnapshot.forEach( doc => {
          tmpGroups.push({name: doc.data().name})
        })
      })
      commit('setGroupsAsAdmin', tmpGroups)
    },
    getTypesForExpense ({commit}, payload) {
      firebase.firestore().collection('expenseSettings').doc(payload.expense + '_' + payload.groupname + '_' + payload.admin).get().then( querysnapshot => {
        commit('setTypesForExpense', querysnapshot.data().types)
        commit('setTimeIntervall', querysnapshot.data().timeIntervall)
      })
    },
    getUsersForGroup ({commit}, payload) {
      let tmpUsers = []
      firebase.firestore().collection('groups').where('admin', '==', firebase.auth().currentUser.email).where('name', '==', payload.groupname).get().then( querysnapshot => {
        querysnapshot.forEach( doc => {
          doc.data().members.forEach( member => {
            if ( member == firebase.auth().currentUser.email) {

            }else {
              tmpUsers.push(member)
            }            
          })          
        })
      })
      commit('setUsersForGroup', tmpUsers)
    },
    getExpensesForGroupAsMember ({commit}, payload) {
      let tmpExpenses = []
      firebase.firestore().collection('groups').where('admin', '==', payload.admin).where('name', '==', payload.groupname).get().then( querysnapshot => {
        querysnapshot.forEach( doc => {
          doc.data().expenseID.forEach( expense => {            
            tmpExpenses.push(expense)                        
          })          
        })
      })      
      commit('setExpensesForGroupAsMember', tmpExpenses)
    },
    getExpensesForGroup ({commit}, payload) {
      let tmpExpenses = []
      firebase.firestore().collection('groups').where('admin', '==', firebase.auth().currentUser.email).where('name', '==', payload.groupname).get().then( querysnapshot => {
        querysnapshot.forEach( doc => {
          doc.data().expenseID.forEach( expense => {            
            tmpExpenses.push(expense)                        
          })          
        })
      })
      commit('setExpensesForGroup', tmpExpenses)
    },
    addUserToGroup ({commit}, payload) {
      commit('setLoading', true)
      let tmpMembers = []
      firebase.firestore().collection('emailToUsername').where('email', '==', payload.user).get().then( querysnapshot => {
        if (querysnapshot.docs.length == 0) {
          commit('setLoading', false)
          commit('setSnackbar', 'Ilyen email címmel nem létezik felhasználó.')
        } else {
          firebase.firestore().collection('groups').where('admin', '==', firebase.auth().currentUser.email).where('name', '==', payload.groupname).get().then( querysnapshot => {
            querysnapshot.forEach( doc => {
              tmpMembers = doc.data().members
              if (tmpMembers.includes(payload.user)) {
                commit('setLoading', false)
                commit('setSnackbar', payload.user + ' már tagja a ' + payload.groupname + ' csoportnak.')
              } else {
                tmpMembers.push(payload.user)
                  firebase.firestore().collection('groups').doc(doc.id).update({members: tmpMembers}).then( event => {
                    firebase.firestore().collection('UsersToGroups').add({admin: firebase.auth().currentUser.email, groupname: payload.groupname, user: payload.user}).catch( error3 => {
                      commit('setLoading', false)
                      commit('setSnackbar', error3.message)
                    })
                    commit('setLoading', false)
                    commit('setSnackbar', payload.user + ' hozzáadva a ' + payload.groupname + ' csoporthoz.')
                  }).catch( error2 => {
                    commit('setLoading', false)
                    commit('setSnackbar', error2.message)
                  })
              }                           
            })       
          }).catch( error => {
            commit('setLoading', false)
            commit('setSnackbar', error.message)
          })
        }
      })  
      firebase.firestore().collection('groups').onSnapshot( doc => {
        let tmpUsers = []
        firebase.firestore().collection('groups').where('admin', '==', firebase.auth().currentUser.email).where('name', '==', payload.groupname).get().then( querysnapshot => {
          querysnapshot.forEach( doc => {
            doc.data().members.forEach( member => {
              if ( member == firebase.auth().currentUser.email) {
  
              }else {
                tmpUsers.push(member)
              }            
            })          
          })
        })
        commit('setUsersForGroup', tmpUsers)
      }) 
    },
    deleteUserFromGroup ({commit}, payload) {
      commit('setLoading', true)
      if(payload.user) {
        firebase.firestore().collection('groups').where('admin', '==', firebase.auth().currentUser.email).where('name', '==', payload.groupname).get().then( querysnapshot => {
          querysnapshot.forEach( doc => {
            let filteredUser = []
            doc.data().members.forEach(member => {
              if (member != payload.user){
                filteredUser.push(member)
              } 
            })
            firebase.firestore().collection('groups').doc(doc.id).update({members: filteredUser}).then( event => {
              firebase.firestore().collection('UsersToGroups').where('admin', '==', firebase.auth().currentUser.email).where('groupname', '==', payload.groupname).where('user', '==', payload.user).get().then(querysnapshot => {
                querysnapshot.forEach( doc => {
                  firebase.firestore().collection('UsersToGroups').doc(doc.id).delete()
                })
              })
              commit('setLoading', false)
              commit('setSnackbar', payload.user + ' eltávolítva a ' + payload.groupname + ' csoportból.')
            }).catch ( error2 => {
              commit('setLoading', false)
              commit('setSnackbar', error2.message)
            })
          })
        }).catch( error => {
          commit('setLoading', false)
          commit('setSnackbar', error.message)
        })
      } else {
        commit('setSnackbar', 'Válassz ki egy usert.')
        commit('setLoading', false)
      }      
    },
    addNewExpanseToGroup ({commit}, payload) {
      commit('setLoading', true)
      let tmpExpenses = []
      firebase.firestore().collection('groups').where('admin', '==', firebase.auth().currentUser.email).where('name', '==', payload.groupname).get().then( querysnapshot => {
        querysnapshot.forEach( doc => {
          tmpExpenses = doc.data().expenseID
          if(tmpExpenses.includes(payload.expense)){
            commit('setLoading', false)
            commit('setSnackbar', 'Ilyen nevű kiadás már létezik.')
          } else {
            if(tmpExpenses.length > 4){
              commit('setLoading', false)
              commit('setSnackbar', 'Teszt fázis alatt maximum 5 kiadásod lehet/csoport.')
            } else {
              firebase.firestore().collection('groups').where('admin', '==', firebase.auth().currentUser.email).where('name', '==', payload.groupname).get().then( querysnapshot => {
                querysnapshot.forEach( doc => {
                  tmpExpenses = doc.data().expenseID
                  tmpExpenses.push(payload.expense)
                  firebase.firestore().collection('groups').doc(doc.id).update({expenseID: tmpExpenses}).then( event => {
                    commit('setLoading', false)
                    commit('setSnackbar', payload.expense + ' hozzáadva a ' + payload.groupname + ' csoporthoz.')
                  }).catch( error2 => {
                    commit('setLoading', false)
                    commit('setSnackbar', error2.message)
                  })
                })                  
                firebase.firestore().collection('expenses').doc(payload.groupname + '_' + firebase.auth().currentUser.email).collection(payload.expense).add({
                  name: null,
                  value: null,                  
                  timeStamp: null,
                  type: null,
                  buyer: null,
                  track: false
                }).catch( error => {
                  commit('setLoading', false)
                  commit('setSnackbar', error.message)
                })
                firebase.firestore().collection('expenseSettings').doc(payload.expense + '_' + payload.groupname + '_' + firebase.auth().currentUser.email).set({
                  types: 
                  [
                    {icon: 'fastfood', name: 'Élelmiszer'},
                    {icon: 'directions_car', name: 'Autó'},
                    {icon: 'directions_bus', name: 'Közlekedés'},
                    {icon: 'local_gas_station', name: 'Gáz'},
                    {icon: 'highlight', name: 'Villany'},
                    {icon: 'waves', name: 'Víz'},  
                    {icon: 'category', name: 'Közös költség'},    
                    {icon: 'home', name: 'Bérleti díj'},               
                  ],
                  name: payload.expense, admin: firebase.auth().currentUser.email, groupname: payload.groupname, timeIntervall: 'havi'
                }).catch( errorEz => {            
                  commit('setLoading', false)
                  commit('setSnackbar', errorEz.message)
                })    
              }).catch( error => {
                commit('setLoading', false)
                commit('setSnackbar', error.message)
              }) 
            }            
          }
        })       
      })      
    },
    deleteExpenseFromGroup ({commit}, payload) {
      commit('setLoading', true)
      if(payload.expense){
        firebase.firestore().collection('groups').where('admin', '==', firebase.auth().currentUser.email).where('name', '==', payload.groupname).get().then( querysnapshot => {
          querysnapshot.forEach( doc => {
            let filteredExpenses = []
            doc.data().expenseID.forEach(expense => {
              if (expense != payload.expense){
                filteredExpenses.push(expense)
              } 
            })
            firebase.firestore().collection('groups').doc(doc.id).update({expenseID: filteredExpenses}).then( event => {
              firebase.firestore().collection('expenseSettings').doc(payload.expense + '_' + payload.groupname + '_' + firebase.auth().currentUser.email).delete().then( event => {
                firebase.firestore().collection('expenses').doc(payload.groupname + '_' + firebase.auth().currentUser.email).collection(payload.expense).get().then( querysnapshot => {
                  querysnapshot.forEach( doc => {
                    firebase.firestore().collection('expenses').doc(payload.groupname + '_' + firebase.auth().currentUser.email).collection(payload.expense).doc(doc.id).delete().then( event => {
                      commit('setLoading', false)
                      commit('setSnackbar', payload.expense + ' eltávolítva a ' + payload.groupname + ' csoportból.')
                    })
                  })
                })                
              }).catch( error4 => {
                commit('setLoading', false)
                commit('setSnackbar', error4.message)
              })              
            }).catch ( error2 => {
              commit('setLoading', false)
              commit('setSnackbar', error2.message)
            })
          })
        }).catch( error => {
          commit('setLoading', false)
          commit('setSnackbar', error.message)
        })
      } else {
        commit('setSnackbar', 'Válasz ki egy kiadási listát!')
        commit('setLoading', false)
      }     
    },
    showSnackBar ({commit}, payload) {
      if (payload.error == 'csoport') {
        commit('setSnackbar', 'Válassz ki egy csoportot!')
      }     
      if (payload.error == 'kiadás') {
        commit('setSnackbar', 'Válassz ki egy kiadást!')
      }  
    },
    saveTimeSettings ({commit}, payload) {
      firebase.firestore().collection('expenseSettings').doc(payload.expense + '_' + payload.groupname + '_' + payload.admin).update({timeIntervall: payload.time}).catch( error => {
        console.log(error.message)
      })
    },
    deleteGroup ({commit}, payload){
      commit('setLoading', true)
      firebase.firestore().collection('UsersToGroups').where('admin', '==', firebase.auth().currentUser.email).where('groupname', '==', payload.groupname).get().then(querysnapshot => {
        querysnapshot.forEach( doc => {
          firebase.firestore().collection('UsersToGroups').doc(doc.id).delete().then(event => {
            firebase.firestore().collection('groups').where('admin', '==', firebase.auth().currentUser.email).where('name', '==', payload.groupname).get().then(querysnapshot => {
              querysnapshot.forEach(doc => {
                doc.data().expenseID.forEach(expense => {
                  firebase.firestore().collection('expenseSettings').doc(expense + '_' + payload.groupname + '_' + firebase.auth().currentUser.email).delete().then( event => {
                    firebase.firestore().collection('expenses').doc(payload.groupname + '_' + firebase.auth().currentUser.email).collection(expense).get().then( querysnapshot => {
                      querysnapshot.forEach( doc => {
                        firebase.firestore().collection('expenses').doc(payload.groupname + '_' + firebase.auth().currentUser.email).collection(expense).doc(doc.id).delete().then( event => {
                          commit('setLoading', false)
                          commit('setSnackbar', payload.groupname + ' törölve.')
                        })
                      })
                      commit('setLoading', false)
                    })
                    commit('setLoading', false) 
                  })
                  commit('setLoading', false)
                })
                firebase.firestore().collection('groups').doc(doc.id).delete().then( event => {
                  firebase.firestore().collection('emailToUsername').where('email', '==', firebase.auth().currentUser.email).get().then(querysnapshot => {
                    querysnapshot.forEach( doc => {
                      let numberofgroups = doc.data().numberOfGroups
                      numberofgroups -= 1
                      firebase.firestore().collection('emailToUsername').doc(doc.id).update({numberOfGroups: numberofgroups})
                    })
                    commit('setLoading', false)
                  })
                  commit('setLoading', false)
                }) 
                commit('setLoading', false) 
              }) 
              commit('setLoading', false)         
            })
            commit('setLoading', false)
          }).catch(error => {
            commit('setLoading', false)
            commit('setSnackbar', error.message)
          })
        })
      })
      firebase.firestore().collection('groups').onSnapshot( doc => {
        let tmpGroups = []
        firebase.firestore().collection('groups').where('admin', '==', firebase.auth().currentUser.email).get().then( querysnapshot => {
          querysnapshot.forEach( doc => {
            tmpGroups.push({name: doc.data().name})
          })
        })
        commit('setGroupsAsAdmin', tmpGroups)
      })   
    },
    saveAsFavourite ({commit}, payload) {
      commit('setLoading', true)
      firebase.firestore().collection('emailToUsername').where('email', '==', firebase.auth().currentUser.email).get().then(querysnapshot => {
        querysnapshot.forEach(doc => {
          firebase.firestore().collection('emailToUsername').doc(doc.id).update({favouriteGroup: payload.groupname, favouriteExpense: payload.expense, favouriteAdmin: payload.admin}).then( event => {
            commit('setLoading', false)
            commit('setSnackbar', payload.groupname + ' és ' + payload.expense + ' elmentve kedvencként.')
          }).catch(error => {
            commit('setLoading', false)
            commit('setSnackbar', error.message)
          })
        })
      })
    },
    getExpensesForReportForYear ({commit}, payload) {
      if(!payload.groupname || !payload.expense) {
        commit('setSnackbar', 'Válassz ki egy csoportot és kiadást.')
      } else {
        if (!payload.year) {
          commit('setSnackbar', 'Válassz ki egy évet.')
        }else {
          let docs = []   
          let username  
          let color      
          let d = new Date()          
          let pics = []  
          firebase.firestore().collection('expenses').doc(payload.groupname + '_' + payload.admin).collection(payload.expense).where('timeYear', '==', ''+payload.year).get().then(querySnapshot => {
            querySnapshot.forEach( doc => {
              if(doc.data().track) {  
                  firebase.firestore().collection('emailToUsername').where('email', '==', doc.data().buyer).get().then( querySnapshot => {
                    querySnapshot.forEach( document => {
                    username = document.data().username  
                    color = document.data().color 
                    let tmpObject = {id: doc.id, name: doc.data().name, email: doc.data().buyer, buyer: username,  color: color, value: doc.data().value, type: doc.data().type, timeStamp: doc.data().timeStamp}                
                    docs.push(tmpObject)   
                  })              
                })            
              }          
            })
            firebase.firestore().collection('UsersToGroups').where('admin', '==', payload.admin).where('groupname', '==', payload.groupname).get().then( querysnapshot => {
              querysnapshot.forEach(record => {
                firebase.firestore().collection('emailToUsername').where('email', '==', record.data().user).get().then(snapShot => {
                  snapShot.forEach(docSnap => {
                    firebase.storage().ref('profilepictures/' + record.data().user).getDownloadURL().then(url => {
                      docs.push({buyer: docSnap.data().username, src: url, email: record.data().user, value: 0})
                    }).catch( error => {
                      docs.push({buyer: docSnap.data().username, email: record.data().user, value: 0})
                    })                       
                  })
                })            
              })
            })   
            commit('setexpenseItemsMonthly', docs)
            commit('setProfilePics', pics)          
          }).catch(error => {
            commit('setSnackbar', error.message)
          }) 
        }        
      }
    },
    getExpensesForReport ({commit}, payload) {
      if(!payload.groupname || !payload.expense) {
        commit('setSnackbar', 'Válassz ki egy csoportot és kiadást.')
      } else {
        if (!payload.year || !payload.month) {
          commit('setSnackbar', 'Válassz ki egy évet és hónapot.')
        }else {
          let docs = []   
          let username  
          let color 
          let month = payload.month + ''            
          if(month < 10) {
            month = '0' + month
          }    
          firebase.firestore().collection('expenses').doc(payload.groupname + '_' + payload.admin).collection(payload.expense).where('timeYear', '==', ''+payload.year).where('timeMonth', '==', month).get().then(querySnapshot => {
            querySnapshot.forEach( doc => {
              if(doc.data().track) { 
                  firebase.firestore().collection('emailToUsername').where('email', '==', doc.data().buyer).get().then( querySnapshot => {
                    querySnapshot.forEach( document => {
                    username = document.data().username  
                    color = document.data().color 
                    let tmpObject = {id: doc.id, name: doc.data().name, email: doc.data().buyer, buyer: username, color: color, value: doc.data().value, type: doc.data().type, timeStamp: doc.data().timeStamp}                
                    docs.push(tmpObject)   
                  })              
                })         
              }          
            })
            firebase.firestore().collection('UsersToGroups').where('admin', '==', payload.admin).where('groupname', '==', payload.groupname).get().then( querysnapshot => {
              querysnapshot.forEach(record => {
                firebase.firestore().collection('emailToUsername').where('email', '==', record.data().user).get().then(snapShot => {
                  snapShot.forEach(docSnap => {
                    firebase.storage().ref('profilepictures/' + record.data().user).getDownloadURL().then(url => {
                      docs.push({buyer: docSnap.data().username, src: url, email: record.data().user, value: 0})
                    }).catch( error => {
                      docs.push({buyer: docSnap.data().username, email: record.data().user, value: 0})
                    })                       
                  })
                })         
              })
            })   
            commit('setexpenseItemsMonthly', docs)                     
          }).catch(error => {
            commit('setSnackbar', error.message)
          })          
        }        
      }
    },
    getExpensesMonthly ({commit}, payload) {  
      let docs = []   
      let username  
      let color      
      let d = new Date()
      let month = d.getMonth() + 1      
      if(month < 10) {
        month = '0' + month
      }  
      firebase.firestore().collection('UsersToGroups').where('admin', '==', payload.admin).where('groupname', '==', payload.groupname).get().then( querysnapshot => {
        querysnapshot.forEach(record => {
          firebase.firestore().collection('emailToUsername').where('email', '==', record.data().user).get().then(snapShot => {
            snapShot.forEach(docSnap => {
              firebase.storage().ref('profilepictures/' + record.data().user).getDownloadURL().then(url => {                  
                docs.push({buyer: docSnap.data().username, src: url, email: record.data().user, value: 0})
              }).catch(error => {
                docs.push({buyer: docSnap.data().username, email: record.data().user, value: 0})
              })                
            })
          })            
        })         
      })      
      firebase.firestore().collection('expenses').doc(payload.groupname + '_' + payload.admin).collection(payload.expense).where('timeYear', '==', ''+d.getFullYear()).where('timeMonth', '==', ''+month).get().then(querySnapshot => {
        querySnapshot.forEach( doc => {
          if(doc.data().track) {                       
            firebase.firestore().collection('emailToUsername').where('email', '==', doc.data().buyer).get().then( querySnapshot => {
                querySnapshot.forEach( document => {
                username = document.data().username  
                color = document.data().color   
                let tmpObject = {id: doc.id, name: doc.data().name, email: doc.data().buyer, buyer: username, color: color, value: doc.data().value, type: doc.data().type, timeStamp: doc.data().timeStamp}                
                docs.push(tmpObject)             
              })              
            })             
          }          
        })             
        commit('setexpenseItemsMonthly', docs)
      }).catch(error => {
        commit('setSnackbar', error.message)
      }) 
      firebase.firestore().collection('expenses').doc(payload.groupname + '_' + payload.admin).collection(payload.expense).onSnapshot( doc => {  
        let docs2 = []
        let username 
        let color
        let d = new Date()
        let month = d.getMonth() + 1
        if(month < 10) {
          month = '0' + month
        }
        firebase.firestore().collection('UsersToGroups').where('admin', '==', payload.admin).where('groupname', '==', payload.groupname).get().then( querysnapshot => {
          querysnapshot.forEach(record => {
            firebase.firestore().collection('emailToUsername').where('email', '==', record.data().user).get().then(snapShot => {
              snapShot.forEach(docSnap => {
                firebase.storage().ref('profilepictures/' + record.data().user).getDownloadURL().then(url => {                    
                  docs2.push({buyer: docSnap.data().username, src: url, email: record.data().user, value: 0})
                }).catch(error => {                    
                  docs2.push({buyer: docSnap.data().username, email: record.data().user, value: 0})
              })   
              })
            })            
          })          
        })
        firebase.firestore().collection('expenses').doc(payload.groupname + '_' + payload.admin).collection(payload.expense).where('timeYear', '==', ''+d.getFullYear()).where('timeMonth', '==', ''+month).get().then(querySnapshot => {
          querySnapshot.forEach( doc => {
            if(doc.data().track) {              
              firebase.firestore().collection('emailToUsername').where('email', '==', doc.data().buyer).get().then( querySnapshot => {
                querySnapshot.forEach( document => {
                  username = document.data().username 
                  color = document.data().color     
                  let tmpObject = {id: doc.id, name: doc.data().name, email: doc.data().buyer, buyer: username, color: color, value: doc.data().value, type: doc.data().type, timeStamp: doc.data().timeStamp}                
                  docs2.push(tmpObject)
                })
              })
            }          
          })                     
          commit('setexpenseItemsMonthly', docs2)  
        }).catch(error => {
          commit('setSnackbar', error.message)
        })
      })      
    },
    getExpenses ({commit}, payload) {
      if(!payload.groupname || !payload.expense) {
        commit('setSnackbar', 'Válassz ki egy csoportot és kiadást.')
      } else {
        let docs = []   
        let username  
        let color
        firebase.firestore().collection('expenses').doc(payload.groupname + '_' + payload.admin).collection(payload.expense).get().then(querySnapshot => {
          querySnapshot.forEach( doc => {
            if(doc.data().track) {                       
              firebase.firestore().collection('emailToUsername').where('email', '==', doc.data().buyer).get().then( querySnapshot => {
                  querySnapshot.forEach( document => {
                  username = document.data().username  
                  color = document.data().color                              
                  let tmpObject = {id: doc.id, name: doc.data().name, email: doc.data().buyer, buyer: username, color: color, value: doc.data().value, type: doc.data().type, timeStamp: doc.data().timeStamp}                
                  docs.push(tmpObject)                
                })              
              })             
            }          
          })                    
          commit('setexpenseItemsAll', docs) 
        }).catch(error => {
          commit('setSnackbar', error.message)
        }) 
        firebase.firestore().collection('expenses').doc(payload.groupname + '_' + payload.admin).collection(payload.expense).onSnapshot( doc => {
          let docs2 = []
          let username 
          let color
          firebase.firestore().collection('expenses').doc(payload.groupname + '_' + payload.admin).collection(payload.expense).get().then(querySnapshot => {
            querySnapshot.forEach( doc => {
              if(doc.data().track) {              
                firebase.firestore().collection('emailToUsername').where('email', '==', doc.data().buyer).get().then( querySnapshot => {
                  querySnapshot.forEach( document => {
                    username = document.data().username 
                    color = document.data().color                                
                    let tmpObject = {id: doc.id, name: doc.data().name, email: doc.data().buyer, buyer: username, color: color, value: doc.data().value, type: doc.data().type, timeStamp: doc.data().timeStamp}
                    docs2.push(tmpObject)
                  })
                })
              }          
            })     
            commit('setexpenseItemsAll', docs2)
          }).catch(error => {
            commit('setSnackbar', error.message)
          })
        })
      }      
    },
    deleteType ({commit}, payload) {
      commit('setLoading', true)              
      firebase.firestore().collection('expenseSettings').doc(payload.expense + '_' + payload.groupname + '_' + payload.admin).get().then(querysnapshot => {        
        let tmpTypes = [] 
        querysnapshot.data().types.forEach(type => {
          if(type.name !== payload.type) {
            tmpTypes.push(type)
          }
        })          
        firebase.firestore().collection('expenseSettings').doc(querysnapshot.id).update({types: tmpTypes})              
        commit('setLoading', false)
        commit('setSnackbar', 'Típus törölve.')
      }).catch(error => {
        commit('setLoading', false)
        commit('setSnackbar', error.message)
      })
      firebase.firestore().collection('expenseSettings').onSnapshot( event => {
        firebase.firestore().collection('expenseSettings').doc(payload.expense + '_' + payload.groupname + '_' + payload.admin).get().then( querysnapshot => {
          commit('setTypesForExpense', querysnapshot.data().types)
          commit('setTimeIntervall', querysnapshot.data().timeIntervall)
        })
      })
    },
    createNewType ({commit}, payload) {
      commit('setLoading', true)
      if(!payload.groupname || !payload.expensename) {
        commit('setSnackbar', 'Válassz ki egy csoportot és kiadást!')
      } else {
        firebase.firestore().collection('expenseSettings').doc(payload.expensename + '_' + payload.groupname + '_' + payload.admin).get().then(querysnapshot => {        
          let tmpTypes = querysnapshot.data().types 
          tmpTypes.push({icon:'folder', name: payload.typename})       
          firebase.firestore().collection('expenseSettings').doc(querysnapshot.id).update({types: tmpTypes}).catch(error => {
            console.log(error.message)
          })              
          commit('setLoading', false)
          commit('setSnackbar', 'Típus hozzáadva.')
        }).catch(error => {
          commit('setLoading', false)
          commit('setSnackbar', error.message)
        })
        firebase.firestore().collection('expenseSettings').onSnapshot( event => {
          firebase.firestore().collection('expenseSettings').doc(payload.expensename + '_' + payload.groupname + '_' + payload.admin).get().then( querysnapshot => {            
            commit('setTypesForExpense', querysnapshot.data().types)
            commit('setTimeIntervall', querysnapshot.data().timeIntervall)
          })
        })
      }
      commit('setLoading', false)
    },
    deleteSelectedExpenses ({commit}, payload) {
      commit('setLoading', true)      
      payload.selected.forEach (item => {     
        if(item.email == firebase.auth().currentUser.email || payload.admin == firebase.auth().currentUser.email) {
          firebase.firestore().collection('expenses').doc(payload.groupname + '_' + payload.admin).collection(payload.expense).doc(item.id).delete().then( event => {
            commit('setLoading', false)
            commit('setSnackbar', 'Törölve.')
          }).catch(error => {
            commit('setLoading', false)
            commit('setSnackbar', error.message)
          })
        } else {
          commit('setLoading', false)
          commit('setSnackbar', 'Más user kiadását nem tudod törölni.')
        }          
      })
      firebase.firestore().collection('expenses').doc(payload.groupname + '_' + payload.admin).collection(payload.expense).onSnapshot( doc => {
        let docs2 = []
        let username 
        firebase.firestore().collection('expenses').doc(payload.groupname + '_' + payload.admin).collection(payload.expense).get().then(querySnapshot => {
          querySnapshot.forEach( doc => {
            if(doc.data().track) {              
              firebase.firestore().collection('emailToUsername').where('email', '==', doc.data().buyer).get().then( querySnapshot => {
                querySnapshot.forEach( document => {
                  username = document.data().username                                
                  let tmpObject = {id: doc.id, name: doc.data().name, email: doc.data().buyer, buyer: username, value: doc.data().value, type: doc.data().type, timeStamp: doc.data().timeStamp}
                  docs2.push(tmpObject)
                })
              })
            }          
          })               
          commit('setexpenseItems', docs2)
        }).catch(error => {
          commit('setSnackbar', error.message)
        })
      })   
    },
    addExpense ({commit}, payload) { 
      if(payload.groupname){
        if(payload.expense) {
          if(payload.type) {
            firebase.firestore().collection('emailToUsername').where('email', '==', firebase.auth().currentUser.email).get().then(querysnapshot => {
              querysnapshot.forEach(doc => {
                var d = new Date()
                let month = d.getMonth() + 1
                let day = d.getDate()
                if((doc.data().numberOfAdd === 10) && (doc.data().lastAdd === (d.getFullYear()+'-'+month+'-'+day))) {
                  commit('setLoading', false)
                  commit('setSnackbar', 'Teszt fázis alatt, maximum 10 kiadást adhatsz hozzá naponta.')
                } else {
                  if(doc.data().lastAdd !== (d.getFullYear()+'-'+month+'-'+day)){
                    firebase.firestore().collection('emailToUsername').doc(doc.id).update({numberOfAdd: 0})
                  }                  
                  firebase.firestore().collection('expenses').doc(payload.groupname + '_' + payload.admin).collection(payload.expense).add({
                    name: payload.expensename,
                    value: payload.value,             
                    timeStamp: payload.date,
                    timeYear: payload.addedYear,
                    timeMonth: payload.addedMonth,
                    type: payload.type,
                    buyer: firebase.auth().currentUser.email,
                    track: true
                }
                ).then(event => {
                  var d = new Date()
                  firebase.firestore().collection('emailToUsername').where('email', '==', firebase.auth().currentUser.email).get().then( querysnapshot => {
                    querysnapshot.forEach(doc => {
                      let month = d.getMonth()+1
                      let day = d.getDate()
                      let numberOfAdds = doc.data().numberOfAdd + 1
                      firebase.firestore().collection('emailToUsername').doc(doc.id).update({numberOfAdd: numberOfAdds, lastAdd: d.getFullYear() + '-' +month + '-' + day}).catch( error => {
                        console.log(error)
                      })
                    })
                  })
                  commit('setLoading', false)
                  commit('setSnackbar', 'Kiadás hozzá adva.')
                }).catch(error => {
                  commit('setLoading', false)
                  commit('setSnackbar', error.message)
                })
                }
              })
            })               
          } else {
            commit('setSnackbar', 'Válassz ki egy típust!')
          }          
        } else {
          commit('setSnackbar', 'Válassz ki egy kiadást!')
        }
      } else {
        commit('setSnackbar', 'Válassz ki egy csoportot!')
      }      
    }
  },
  getters: {
    isAuthenticated (state) {
      return state.user !== null && state.user !== undefined && state.user.emailVerified !== false
    },
    expenseItem (state) {
      return state.expenseItemsMonthly
    }
  }
})


// WEBPACK FOOTER //
// ./src/store/index.js